import { Coupon } from '../@types';
import { RequestApi } from '../helpers';

const getCouponByCode = async (couponCode: string) => {
  const response = await RequestApi.get<Coupon>(
    `/coupons/getByCode/${couponCode}`,
  );
  return response;
};

const couponService = {
  getCouponByCode,
};

export default couponService;
